<br /><br />

@if (!disableGraph()) {
  <mat-accordion>
    <mat-expansion-panel [expanded]="graphOpen" [disabled]="graphOpen" (opened)="graphOpen = true"
      (closed)="graphOpen = false">
      @if (!graphOpen) {
        <mat-expansion-panel-header>
          Gráfica
        </mat-expansion-panel-header>
      }
      <ng-template matExpansionPanelContent>
        @if (!isFixedRange()) {
          <div>
            <dx-chart [dataSource]="datasource">
              <dxo-loading-indicator [enabled]="true"></dxo-loading-indicator>
              <dxo-size [height]="500" width="80%"></dxo-size>
              @for (sensor of sensors; track sensor) {
                <dxi-series [valueField]="sensor.value" [name]="sensor.name">
                </dxi-series>
              }
              <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip" [zIndex]="5000"></dxo-tooltip>
              <dxi-value-axis>
                <dxi-constant-line [width]="2" [value]="minMaxValue.minValue" color="#8c8cff" dashStyle="dash">
                  <dxo-label text="Criterio mínimo"></dxo-label>
                </dxi-constant-line>
                <dxi-constant-line [width]="2" [value]="minMaxValue.maxValue" color="#ff7c7c" dashStyle="dash">
                  <dxo-label text="Criterio máximo"></dxo-label>
                </dxi-constant-line>
              </dxi-value-axis>
              <dxo-argument-axis argumentType="datetime">
                <dxo-label [format]="customizeDateLabel"></dxo-label>
                @for (def of defrosts; track def) {
                  <dxi-constant-line [width]="2" [value]="def.startDate" color="green"
                    dashStyle="longDash">
                    <dxo-label text="Inicio" horizontalAlignment="left"></dxo-label>
                  </dxi-constant-line>
                }
                @for (def of defrosts; track def) {
                  <dxi-constant-line [width]="2" [value]="def.endDate" color="red"
                    dashStyle="longDash">
                    <dxo-label text="Fin {{ def.nameType || lowercase }}" horizontalAlignment="right"></dxo-label>
                  </dxi-constant-line>
                }
              </dxo-argument-axis>
              <dxo-common-series-settings argumentField="date" type="line">
              </dxo-common-series-settings>
            </dx-chart>
          </div>
        }
        @if (isFixedRange()) {
          <div>
            <dx-range-selector #graph id="range-selector" [value]="[minDate, maxDate]" [dataSource]="datasource"
              (onValueChanged)="onValueChanged($event)" (onIncidentOccurred)="onError($event)" [disabled]="disableRange()"
              style="width: 100%">
              <dxo-size [height]="500" width="80%"></dxo-size>
              <dxo-behavior [snapToTicks]="false"></dxo-behavior>
              <dxo-scale argumentType="datetime">
                <dxo-tick-interval [hours]="1"></dxo-tick-interval>
                <dxo-max-range [days]="maxDaysRange()" [hours]="maxHoursRange()" [minutes]="maxMinutesRange()">
                </dxo-max-range>
                <dxo-min-range [days]="minDaysRange()" [hours]="minHoursRange()" [minutes]="minMinutesRange()">
                </dxo-min-range>
                <dxo-minor-tick [visible]="false"></dxo-minor-tick>
                <dxo-marker [visible]="false"></dxo-marker>
                <dxo-label [customizeText]="customizeLabel"></dxo-label>
              </dxo-scale>
              <dxo-slider-marker [customizeText]="customizeSliderMarker" invalidRangeColor="white">
              </dxo-slider-marker>
              <dxo-chart (onDisposing)="showLoading()" (onDone)="hideLoading()">
                <dxo-loading-indicator [enabled]="true"></dxo-loading-indicator>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip" [zIndex]="5000"></dxo-tooltip>
                @for (sensor of sensors; track sensor) {
                  <dxi-series [valueField]="sensor.value" [name]="sensor.name"></dxi-series>
                }
                <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="bottom">
                </dxo-legend>
                <dxo-common-series-settings argumentField="date" type="line"></dxo-common-series-settings>
              </dxo-chart>
            </dx-range-selector>
          </div>
        }
        <br />
        <div fxLayout="row" fxLayout.xs="column" class="flexwrap padding10">
          @if (isFixedRange()) {
            <div fxFlex="50" fxFlex.lt-md="100%">
              {{ 'executionEdit.essays.graph.form.filter.label' | translate }}
              <mat-form-field>
                <mat-label>{{ 'common.start.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="dateZoomInitStr"
                  [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'common.end.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="dateZoomEndStr"
                  [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <button mat-icon-button color="accent" (click)="recalculateDateFilter()">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          }
          @if (showCopyDateFirstSensor() && isFixedRange()) {
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-checkbox class="example-margin" (change)="onCopyTimeGraphChange($event)" [value]="item"
                [checked]="copyDateFirstSensor">
                {{ 'executionEdit.essays.graph.form.copyDates.label' | translate }}
              </mat-checkbox>
            </div>
          }
          <div fxFlex="50" fxFlex.lt-md="100%"></div>
        </div>
        @if (isFixedRange()) {
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap padding10">
            <div fxFlex="100" fxFlex.lt-md="100%">
              {{ 'executionEdit.essays.graph.form.exhibitionTime.label' | translate }}
              {{ 'executionEdit.essays.graph.form.exhibitionTime.from' | translate }} {{ minDate | fixDateTime }}
              {{ 'executionEdit.essays.graph.form.exhibitionTime.to' | translate }} {{ maxDate | fixDateTime }}
            </div>
            @for (data of calculatedData; track data) {
              <div fxFlex="30" fxFlex.lt-md="100%">
                <p style="font-weight: bold"> {{ 'executionEdit.essays.graph.form.calculatedData.sensorName' | translate }}
                {{ data.equipmentName }} ({{ data.serialNum }}) </p>
                <p> {{ 'executionEdit.essays.graph.form.calculatedData.min' | translate }} {{ data.minValue }} </p>
                <p> {{ 'executionEdit.essays.graph.form.calculatedData.average' | translate }} {{ data.average }} </p>
                <p> {{ 'executionEdit.essays.graph.form.calculatedData.max' | translate }} {{ data.maxValue }} </p>
                <p> {{ 'executionEdit.essays.graph.form.calculatedData.minAvg' | translate }} {{ data.diffAvgMin }} </p>
                <p> {{ 'executionEdit.essays.graph.form.calculatedData.avgMax' | translate }} {{ data.diffMaxAvg }} </p>
                <p> {{ 'executionEdit.essays.graph.form.calculatedData.minMax' | translate }} {{ data.diffMaxMin }} </p>
                <p> {{ 'executionEdit.essays.graph.form.calculatedData.standardDeviation' | translate }}
                {{ data.standardDeviation | number:'1.2-2' }} </p>
                @if (showMkt) {
                  <p> {{ 'executionEdit.essays.graph.form.calculatedData.mkt' | translate }}
                  {{ data.mkt | number:'1.2-2' }} </p>
                }
                @if (data.outer) {
                  <p>
                    {{ 'executionEdit.essays.graph.form.calculatedData.outer' | translate }}
                  </p>
                }
                @if (data.isErrMax && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isErrMax' | translate }} </p>
                }
                @if (data.isErrMin && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isErrMin' | translate }} </p>
                }
                @if (data.isErrPeakMax && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isErrPeakMax' | translate }} </p>
                }
                @if (data.isErrPeakMin && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isErrPeakMin' | translate }} </p>
                }
                @if (data.isColdSpot && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isColdSpot' | translate }} </p>
                }
                @if (data.isHotSpot && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isHotSpot' | translate }} </p>
                }
                @if (data.isErrMaxDelta && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isErrMaxDelta' | translate }} </p>
                }
                @if (data.isErrMinDelta && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isErrMinDelta' | translate }} </p>
                }
                @if (data.isErrMaxStandardDeviation && !data.outer) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isErrMaxStandardDeviation' | translate }} </p>
                }
                @if (data.isErrDiffAvg || data.isErrorDiffMax) {
                  <p [class]="getClassError(data)">
                  {{ 'executionEdit.essays.graph.form.calculatedData.isDiffErrAvgMin' | translate }} </p>
                }
                @if (data.isColdSpot || data.isHotSpot) {
                  <div>
                    @if (data.isColdSpot) {
                      <p>
                        {{ 'executionEdit.essays.graph.form.calculatedData.isColdSpot.title' | translate }}
                      </p>
                    }
                    @if (data.isHotSpot) {
                      <p>
                        {{ 'executionEdit.essays.graph.form.calculatedData.isHotSpot.title' | translate }}
                      </p>
                    }
                    <mat-radio-group [(ngModel)]="data.hotColdSpot" name="hotColdSpot{{data.equipmentName}}"
                      [ngModelOptions]="{standalone: true}">
                      <mat-radio-button [value]="true" (change)="onHotColdSpotChange(data.equipmentName, $event)">
                        {{'common.yes' | translate}}
                      </mat-radio-button>
                      <mat-radio-button [value]="false" (change)="onHotColdSpotChange(data.equipmentName, $event)">
                        {{'common.no' | translate}}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                }
                <br />
              </div>
            }
          </div>
        }
        @if (isEventEssay() && eventValue != null) {
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap padding10">
            <div fxFlex="50" fxFlex.lt-md="100%">
              {{ 'executionEdit.essays.graph.form.exhibitionTime.label' | translate }}
              {{ 'executionEdit.essays.graph.form.exhibitionTime.from' | translate }}
              {{ eventValue?.startDateShow | fixDateTime }}
              {{ 'executionEdit.essays.graph.form.exhibitionTime.to' | translate }}
              {{ eventValue?.endDateShow | fixDateTime }}
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%"></div>
            <div fxFlex="20" fxFlex.lt-md="100%">
              <p style="font-weight: bold">{{ 'executionEdit.essays.graph.form.event.labelBeforeEvent' | translate }}</p>
              <p> {{ 'executionEdit.essays.graph.form.event.min' | translate }} {{ eventValue?.minValueBefore }} </p>
              <p> {{ 'executionEdit.essays.graph.form.event.average' | translate }} {{ eventValue?.avgValueBefore }} </p>
              <p> {{ 'executionEdit.essays.graph.form.event.max' | translate }} {{ eventValue?.maxValueBefore }} </p>
            </div>
            <div fxFlex="20" fxFlex.lt-md="100%">
              <p style="font-weight: bold">{{ 'executionEdit.essays.graph.form.event.labelUntilCriteria' | translate }}</p>
              @if (eventValue?.timeEventDate == null) {
                <p class="error">
                  {{ 'executionEdit.essays.graph.form.event.untilCriteriaEmpty' | translate }}
                </p>
              }
              @if (eventValue?.timeEventDate != null) {
                <p>
                  {{ 'executionEdit.essays.graph.form.event.date' | translate }} {{ eventValue?.timeEvent }}
                </p>
              }
              @if (eventValue?.timeEventDate != null) {
                <p>
                  {{ 'executionEdit.essays.graph.form.event.labelUntilCriteriaDate' | translate }}
                  {{ eventValue?.timeEventDate | fixDateTime }}
                </p>
              }
              @if (eventValue?.timeEventDate != null) {
                <p [class]="classForPeakMax()">
                  {{ 'executionEdit.essays.graph.form.event.peakValueMax' | translate }} {{ eventValue?.peakValueMax }}
                </p>
              }
              @if (eventValue?.timeEventDate != null) {
                <p [class]="classForPeakMin()">
                  {{ 'executionEdit.essays.graph.form.event.peakValueMin' | translate }} {{ eventValue?.peakValueMin }}
                </p>
              }
              <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                <div fxFlex="50">
                  <span> {{ 'executionEdit.essays.graph.form.event.peak.type.label' | translate }} </span>
                </div>
                <div fxFlex="40">
                  <mat-select required name="idPeak" [(ngModel)]="idPeak" (selectionChange)="onIdPeakChange($event)">
                    @for (item of peakTypes; track item) {
                      <mat-option [value]="item.id">
                        {{ 'executionEdit.essays.graph.form.event.peak.' + item.translation + '.label' | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              </div>
            </div>
            <div fxFlex="20" fxFlex.lt-md="100%">
              <p style="font-weight: bold">{{ 'executionEdit.essays.graph.form.event.labelAfterStability' | translate }}</p>
              @if (eventValue?.timeAfterDate == null) {
                <p class="error">
                  {{ 'executionEdit.essays.graph.form.event.stabilityEmpty' | translate }}
                </p>
              }
              <p> {{ 'executionEdit.essays.graph.form.event.date' | translate }} {{ eventValue?.timeAfter }} </p>
              @if (eventValue?.timeAfterDate) {
                <p>
                  {{ 'executionEdit.essays.graph.form.event.labelAfterStabilityDate' | translate }}
                  {{ eventValue?.timeAfterDate | fixDateTime }}
                </p>
              }
              @if (eventValue?.minValueAfter) {
                <p>
                  {{ 'executionEdit.essays.graph.form.event.min' | translate }} {{ eventValue?.minValueAfter }}
                </p>
              }
              @if (eventValue?.avgValueAfter) {
                <p>
                  {{ 'executionEdit.essays.graph.form.event.average' | translate }} {{ eventValue?.avgValueAfter }}
                </p>
              }
              @if (eventValue?.maxValueAfter) {
                <p>
                  {{ 'executionEdit.essays.graph.form.event.max' | translate }} {{ eventValue?.maxValueAfter }}
                </p>
              }
            </div>
            <div fxFlex="20" fxFlex.lt-md="100%">
              <p style="font-weight: bold">Salida de criterio</p>
              @if (eventValue?.firstOutOfCriteria) {
                <div>
                  @if (eventValue?.firstOutOfCriteriaDate) {
                    <div>
                      {{ 'executionEdit.essays.graph.form.event.firstOutOfCriteria' | translate : { sensor: eventValue?.firstOutOfCriteria, date: eventValue?.firstOutOfCriteriaDate | fixDateTime } }}
                    </div>
                  }
                </div>
              }
              <!--<div *ngIf="eventValue?.lastOutOfCriteria">
              <div *ngIf="eventValue?.lastOutOfCriteriaDate">
                {{ 'executionEdit.essays.graph.form.event.lastOutOfCriteria' | translate : { sensor: eventValue?.lastOutOfCriteria, date: eventValue?.lastOutOfCriteriaDate | fixDateTime } }}
              </div>
              <div *ngIf="!eventValue?.lastOutOfCriteriaDate">
                {{ 'executionEdit.essays.graph.form.event.lastOutOfCriteria.none' | translate : { sensor: eventValue?.lastOutOfCriteria } }}
              </div>
            </div>-->
          </div>
          <div fxFlex="20" fxFlex.lt-md="100%">
            <p style="font-weight: bold">Entrada a criterio</p>
            <!--<div *ngIf="eventValue?.firstInCriteria">
            <div *ngIf="eventValue?.firstInCriteriaDate">
              {{ 'executionEdit.essays.graph.form.event.firstInCriteria' | translate : { sensor: eventValue?.firstInCriteria, date: eventValue?.firstInCriteriaDate | fixDateTime } }}
            </div>
          </div> -->
          @if (eventValue?.lastInCriteria) {
            <div>
              @if (eventValue?.lastInCriteriaDate) {
                <div>
                  {{ 'executionEdit.essays.graph.form.event.lastInCriteria' | translate : { sensor: eventValue?.lastInCriteria, date: eventValue?.lastInCriteriaDate | fixDateTime } }}
                </div>
              }
            </div>
          }
          @if (eventValue?.probeNeverRecovers) {
            <div>
              <div>
                {{ 'executionEdit.essays.graph.form.event.neverRecovers' | translate : { sensor: eventValue?.probeNeverRecovers } }}
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (lethalityValue != null && lethalityValue.length > 0) {
      <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
        >
        <div fxFlex="100">
          {{ 'executionEdit.essays.graph.form.exhibitionTime.label' | translate }}
          {{ 'executionEdit.essays.graph.form.exhibitionTime.from' | translate }} {{minDate | fixDateTime }}
          {{ 'executionEdit.essays.graph.form.exhibitionTime.to' | translate }} {{maxDate | fixDateTime }}
        </div>
        @for (data of lethalityValue; track data) {
          <div fxFlex="16" fxFlex.lt-md="100%">
            <p style="font-weight: bold"> {{ 'executionEdit.essays.graph.form.calculatedData.sensorName' | translate }}
            {{ data.sensorName }} ({{ data.serialNum }}) </p>
            @if (data.showAccumulated || data.showTotal) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.labelStartExhibition' | translate }}
                {{ data.initExhibition }}
              </p>
            }
            @if (data.showAccumulated) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.labelEndExhibition' | translate }} {{ data.endExhibition }}
              </p>
            }
            @if (data.showTotal || data.showHundredToEnd) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.labelEndEssay' | translate }} {{ data.endEssay }}
              </p>
            }
            @if (data.showHundredToHundred || data.showHundredToEnd) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.labelAt100Degree' | translate }} {{ data.init100Degree }}
              </p>
            }
            @if (data.showHundredToHundred) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.labelDown100Degree' | translate }} {{ data.end100Degree }}
              </p>
            }
            @if (data.showAccumulated) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.accumulated' | translate }} {{ data.accumulated }}
              </p>
            }
            @if (data.showTotal) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.total' | translate }} {{ data.total }}
              </p>
            }
            @if (data.showHundredToHundred) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.hundredToHundred' | translate }}
                {{ data.hundredToHundred }}
              </p>
            }
            @if (data.showHundredToEnd) {
              <p>
                {{ 'executionEdit.essays.graph.form.lethality.hundredToEnd' | translate }} {{ data.hundredToEnd }}
              </p>
            }
            @if (data.showAccumulated && data.accumulated < data.lethalityCriteria) {
              <p [class]="getClassError(data)">
                {{ 'executionEdit.essays.graph.form.lethality.isErrAccumulatedMin' | translate }}
              </p>
            }
            @if (data.showTotal && data.total < data.lethalityCriteria) {
              <p [class]="getClassError(data)">
                {{ 'executionEdit.essays.graph.form.lethality.isErrTotalMin' | translate }}
              </p>
            }
            @if (data.showHundredToHundred && data.hundredToHundred < data.lethalityCriteria) {
              <p
                [class]="getClassError(data)">
                {{ 'executionEdit.essays.graph.form.lethality.isErrHundredToHundredMin' | translate }}
              </p>
            }
            @if (data.showHundredToEnd && data.hundredToEnd < data.lethalityCriteria) {
              <p [class]="getClassError(data)">
                {{ 'executionEdit.essays.graph.form.lethality.isErrHundredToEndMin' | translate }}
              </p>
            }
          </div>
        }
      </div>
    }
    <mat-toolbar color="secondary">
      {{ 'isothermalCharacterizationEdit.essays.graph.form.summaryData.title' | translate }}
    </mat-toolbar>
    <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
      <div fxFlex="100" fxFlex.lt-md="100%" style="padding: 10px;">
        @for (item of avgSensors; track item) {
          <div fxLayout="column">
            <p fxFlex="100" class="error">
              {{item}}
            </p>
          </div>
        }
        @for (item of diffAvarages; track item) {
          <div fxLayout="column">
            <p fxFlex="100" class="error">
              {{item}}
            </p>
          </div>
        }
        @for (item of diffProbeRespectAvg; track item) {
          <div fxLayout="column">
            <p fxFlex="100" class="error">
              {{item}}
            </p>
          </div>
        }
      </div>
    </div>
  </ng-template>
</mat-expansion-panel>
</mat-accordion>
}